module.exports = __webpack_public_path__ + "static/media/prescription.cf8c93f5.svg";